<template>
  <div class="search-bar-container d-flex align-items-center px-3 py-2 border-bottom bg-white">
    <!-- Search Input Wrapper -->
    <div class="flex-grow-1 d-flex align-items-center me-3">
      <div class="input-group custom-input-group">
        <input 
          type="text" 
          class="form-control border-0 bg-search-gray" 
          placeholder="Search by Name, ID, HW ID, Branch, etc..." 
          v-model="localSearch"
          @input="handleInput"
        />
        <!-- Functional Refresh Button -->
        <button 
          class="btn btn-refresh border-start" 
          type="button"
          @click="onRefreshClick"
        >
          <i class="fas fa-sync-alt text-secondary"></i>
        </button>
      </div>
    </div>

    <!-- Limit Selector -->
    <div class="d-flex align-items-center limit-section">
      <label class="text-xs text-secondary mb-0 me-2">Limit:</label>
      <select 
        :value="limit" 
        @change="$emit('update:limit', parseInt($event.target.value))" 
        class="form-select form-select-sm limit-dropdown"
      >
        <option :value="20">20</option>
        <option :value="50">50</option>
        <option :value="100">100</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    limit: Number,
    search: String
  },
  data() {
    return {
      localSearch: this.search
    };
  },
  watch: {
    search(newVal) {
      this.localSearch = newVal;
    }
  },
  methods: {
    handleInput() {
      this.$emit('update:search', this.localSearch);
    },
    onRefreshClick() {
      // Emit the refresh event to the parent
      this.$emit('refresh');
    }
  }
}
</script>

<style scoped>
.search-bar-container {
  min-height: 65px;
}

/* The box containing both input and button */
.custom-input-group {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e9ecef;
  background-color: #f8f9fa; /* Light gray background */
  height: 45px; /* Fixed height for consistency */
}

.bg-search-gray {
  background-color: transparent !important; /* Let parent background show */
  font-size: 0.85rem;
  height: 100%;
}

.btn-refresh {
  border: none;
  background-color: #f8f9fa;
  width: 50px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
  border-left: 1px solid #dee2e6 !important; /* Divider line */
}

.btn-refresh:hover {
  background-color: #f1f3f5;
}

.btn-refresh:active {
  background-color: #e9ecef;
}

.limit-dropdown {
  width: 75px;
  height: 38px;
  border-radius: 8px;
  font-size: 13px;
  border: 1px solid #e9ecef;
}

.text-xs { font-size: 12px; font-weight: 600; }

/* Remove blue focus outline */
.form-control:focus {
  box-shadow: none;
  background-color: transparent;
}
</style>